export interface NavDropdownItem {
  id: string;
  dp_itm: string;
  url: string;
  icon: string;
}

export interface NavItem {
  id: string;
  itm: string;
  url: string;
  dropdown: boolean;
  /** Drives custom dropdown UI + active route matching */
  nav_variant?: string;
  dropdown_itms?: NavDropdownItem[];
  dropdown_kicker?: string;
  dropdown_title?: string;
  /** Renders the wide mega-menu layout. No entry currently sets this. */
  mega_menu?: boolean;
}

export const navData: NavItem[] = [
  {
    id: "au@2331",
    itm: "SERVICES",
    /** Drives custom dropdown UI + active route matching */
    nav_variant: "freelancers",
    url: "#",
    dropdown: true,
    dropdown_itms: [
      {
        id: "du@012s",
        dp_itm: "Global Payouts",
        url: "/index-2",
        icon: "fa-solid fa-earth-americas",
      },
      {
        id: "du@013s",
        dp_itm: "Quick Setup",
        url: "/index-3",
        icon: "fa-solid fa-bolt",
      },
      {
        id: "du@014s",
        dp_itm: "Wire & ACH",
        url: "/index-4",
        icon: "fa-solid fa-building-columns",
      },
      {
        id: "du@015s",
        dp_itm: "Crypto Conversion",
        url: "/index-5",
        icon: "fa-solid fa-arrow-right-arrow-left",
      },
      {
        id: "du@016s",
        dp_itm: "Crypto Transfers",
        url: "/index-6",
        icon: "fa-solid fa-paper-plane",
      },
      {
        id: "du@017s",
        dp_itm: "Payment Methods",
        url: "/index-7",
        icon: "fa-solid fa-wallet",
      },
      {
        id: "du@018s",
        dp_itm: "Live Alerts",
        url: "/index-8",
        icon: "fa-solid fa-bell",
      },
      {
        id: "du@019s",
        dp_itm: "Earnings Insights",
        url: "/index-9",
        icon: "fa-solid fa-chart-line",
      },
      {
        id: "du@020s",
        dp_itm: "Bank-Grade Security",
        url: "/index-10",
        icon: "fa-solid fa-shield-halved",
      },
      {
        id: "du@021s",
        dp_itm: "Mobile App",
        url: "/index-11",
        icon: "fa-solid fa-mobile-screen-button",
      },
    ],
  },
  {
    id: "au@2380362",
    itm: "About Us",
    nav_variant: "about",
    url: "#",
    dropdown: true,
    dropdown_kicker: "About OracleMarket",
    dropdown_title: "Learn who we are and how we operate worldwide",
    dropdown_itms: [
      {
        id: "about@001",
        dp_itm: "Who we are",
        url: "/about-us",
        icon: "fa-solid fa-circle-info",
      },
      {
        id: "about@002",
        dp_itm: "Our team",
        url: "/our-team",
        icon: "fa-solid fa-people-group",
      },
      {
        id: "about@003",
        dp_itm: "Fees",
        url: "/fees",
        icon: "fa-solid fa-file-invoice-dollar",
      },
      {
        id: "about@004",
        dp_itm: "Privacy & Policy",
        url: "/privacy-policy",
        icon: "fa-solid fa-user-shield",
      },
      {
        id: "about@005",
        dp_itm: "Countries",
        url: "/countries",
        icon: "fa-solid fa-earth-americas",
      },
      {
        id: "about@006",
        dp_itm: "Reviews",
        url: "/reviews",
        icon: "fa-solid fa-star",
      },
    ],
  },
  {
    id: "au@2380361",
    itm: "Contact",
    url: "/contact",
    dropdown: false,
  },
  {
    id: "au@238301",
    itm: "Help",
    nav_variant: "help",
    url: "#",
    dropdown: true,
    dropdown_kicker: "Help & Support",
    dropdown_title: "Find guidance and resources quickly",
    dropdown_itms: [
      {
        id: "help@001",
        dp_itm: "FAQ",
        url: "/faqs",
        icon: "fa-solid fa-circle-question",
      },
      {
        id: "help@002",
        dp_itm: "Support Center",
        url: "/help-center",
        icon: "fa-solid fa-life-ring",
      },
      {
        id: "help@003",
        dp_itm: "How Works",
        url: "/how-works",
        icon: "fa-solid fa-gears",
      },
      {
        id: "help@004",
        dp_itm: "Blogs",
        url: "/blog",
        icon: "fa-solid fa-newspaper",
      },
    ],
  },
];
